<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'USERS_AND_ROLES', pageCode: 'ALL', subPageCode: 'VIEW' }">
<div class="grid mt-1 details-div bg-white pt-2 pb-2">
    <div class="col-10 lg:col-10 md:col-10 pl-2">
        <div class="initial-details mb-1 ml-3">
            <div class="inline-flex align-items-center">
                <label class="category-name mr-3">{{userDetails?.userCode}}</label>
                <span [class]="userDetails?.active ? 'status-dot active' : 'status-dot inactive'" style="width: 7px; height: 7px;"></span>
                <label class="text-sm">{{userDetails?.active ? 'Active' : 'Inactive'}}</label>
            </div>
        </div>
        <div class="other-details">
            <span class="ml-3">{{userDetails?.firstName}} {{userDetails?.lastName}}
                 <label class="separator">|</label>
                    <span>{{userDetails?.email}}</span>
            </span>
        </div>
    </div>
    <div class="col-2 text-right flex align-items-center justify-content-end">
        <div appAccessProvider [accessCode]="{ menuCode: 'USERS_AND_ROLES', pageCode: 'ALL', subPageCode: 'EDIT' }">
            <button (click)="edit()" pButton class="edit-btn border-400 bg-white text-color mr-1 pl-2 pr-2 pt-1 pb-1 mr-4 hover:surface-100" [label]="editBtnLabel">
                <i class="mi-lg mr-2 edit-pen edit_pencil wh-16"></i>
            </button>
        </div>
    </div>
</div>

<div class="grid mt-2 px-3 overview-details">
    <div class="col-6 md:col-12 lg:col-6 pl-0">
        <div class="card p-fluid border-0">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>manage_users.lbl_details</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer cursor-pointer" (click)="edit()">
                    <label class="card-action" translate>manage_users.lbl_edit</label>
                    <i class="mi-lg edit_pencil ml-1"></i>
                </div>
            </div>
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.lbl_status</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    @if (userDetails) {
                        <span [class]="userDetails?.active ? 'status-dot active' : 'status-dot inactive'"></span>
                        <label class="detail-value">{{userDetails?.active ? 'Active' : 'Inactive'}}</label>
                    }
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_id</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{userDetails?.userCode || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_first_name</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{userDetails?.firstName || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_last_name</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value"> {{userDetails?.lastName || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_phone_number</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                      <label class="detail-value">{{ (userDetails?.countryCode && userDetails?.contactNumber) ? '+' + userDetails.countryCode + '-' + userDetails.contactNumber : '--' }}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_user_email</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{userDetails?.email || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_user_type</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{userDetails?.userType ? (userDetails?.userType | titlecase ) : '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.columns.lbl_parent</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{userDetails?.parentName || '--'}}</label>
                </div>
            </div>
            <hr class="hr-line">
            <div class="grid">
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-heading" translate>manage_users.lbl_role</label>
                </div>
                <div class="col-6 pb-1 mt-1 mb-1">
                    <label class="detail-value">{{roleName || '--'}}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 md:col-12 lg:col-6 pr-0">
        <div class="card p-fluid border-0 pb-2">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase" translate>manage_users.lbl_credential</label>
                </div>
            </div>
            <hr class="hr-line mb-2">
            <div class="grid flex align-items-center">
                <div class="col-3 pb-1 mt-1 mb-1">
                    <div class="flex justify-content-start">
                        <p-button [label]="'manage_users.lbl_reset_password' | translate" [outlined]="true" severity="danger" (click)="onShowDialog()" />
                    </div>
                </div>
                <div class="col-9 pb-1 mt-1 mb-1">
                    <p class="text-sm text-500" translate>manage_users.reset_info</p>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<p-dialog [header]="'manage_users.lbl_reset_password' | translate" [(visible)]="visible" [modal]="true" [draggable]="false" (onHide)="onHide()" [style]="{width: '50vw'}">
    <form [formGroup]="defaultPasswordForm">
        <div class="pt-16">
            <div class="mb-1">
                <label class="font-bold" translate>manage_users.lbl_default_password</label>
                <span class="text-red-500 ml-1">*</span>
            </div>
            
                <div class="form-control">
                    <p-password 
                    formControlName="newPassword" 
                    class="p-component p-element w-full" 
                    [toggleMask]="true" 
                    inputStyleClass="w-full"
                    class="password-input mt-2 mb-2"  
                    [placeholder]="'ph_new_password' | translate">
                    </p-password>
                    <div class="mt-1">
                        <label class="font-12" for="newPassword">
                            {{ 'lbl_must_be_at_least_char_long' | translate:{minLength, maxLength} }}
                        </label>
                    </div>
                    <div>
                        <label class="font-12" for="newPassword">{{passwordRequirementsMessage}}</label>
                    </div>
                </div>
                @if (defaultPasswordForm?.controls?.newPassword?.errors && (defaultPasswordForm?.controls?.newPassword?.dirty || defaultPasswordForm?.controls?.newPassword?.touched) && submitted ) {
                    @if(defaultPasswordForm?.controls?.newPassword?.errors?.required){
                        <div class="form-errors mt-1 required-field" translate>
                            <i class="error_outline"></i>
                            lbl_password_required
                        </div>
                    }
                    @if(!defaultPasswordForm?.controls?.newPassword?.errors?.pattern){
                        <div class="form-errors mt-1 required-field" translate>
                            <i class="error_outline"></i>
                            settings.password_pattern
                        </div>
                    }
                }
        </div>
    </form>
    <div class="col-12 flex justify-content-end px-0 py-3">
        <button class="border-none mr-2 bg-white border-button default-text-light-black-color cursor-pointer" (click)="onHide()" [label]="'cancel' | translate" pButton></button>
        <p-button [label]="'manage_users.lbl_reset_password' | translate" severity="danger" (click)="onResetPassword()"></p-button>
    </div>
</p-dialog>